'use strict';

var utcToZonedTime = require('date-fns-tz/utcToZonedTime');
var compareAsc = require('date-fns/compareAsc');
var differenceInCalendarDays = require('date-fns/differenceInCalendarDays');
var differenceInDays = require('date-fns/differenceInDays');
var differenceInHours = require('date-fns/differenceInHours');
var differenceInMinutes = require('date-fns/differenceInMinutes');
var differenceInMonths = require('date-fns/differenceInMonths');
var differenceInYears = require('date-fns/differenceInYears');
var format = require('./format.cjs');

function _interopDefault (e) { return e && e.__esModule ? e.default : e; }

var utcToZonedTime__default = /*#__PURE__*/_interopDefault(utcToZonedTime);
var compareAsc__default = /*#__PURE__*/_interopDefault(compareAsc);
var differenceInCalendarDays__default = /*#__PURE__*/_interopDefault(differenceInCalendarDays);
var differenceInDays__default = /*#__PURE__*/_interopDefault(differenceInDays);
var differenceInHours__default = /*#__PURE__*/_interopDefault(differenceInHours);
var differenceInMinutes__default = /*#__PURE__*/_interopDefault(differenceInMinutes);
var differenceInMonths__default = /*#__PURE__*/_interopDefault(differenceInMonths);
var differenceInYears__default = /*#__PURE__*/_interopDefault(differenceInYears);

const formatRelativeTime = (params) => {
  const { date, baseDate, locale, timeZone } = params;
  const sign = compareAsc__default(date, baseDate);
  if (sign < 0) {
    return format({
      presetName: "datetime_short",
      date,
      locale,
      timeZone
    });
  }
  const zonedDate = utcToZonedTime__default(date, timeZone);
  const zonedBaseDate = utcToZonedTime__default(baseDate, timeZone);
  const diffMinutes = differenceInMinutes__default(zonedDate, zonedBaseDate);
  const diffHours = differenceInHours__default(zonedDate, zonedBaseDate);
  const diffDays = differenceInDays__default(zonedDate, zonedBaseDate);
  const diffCalDays = differenceInCalendarDays__default(zonedDate, zonedBaseDate);
  const diffMonths = differenceInMonths__default(zonedDate, zonedBaseDate);
  const diffYears = differenceInYears__default(zonedDate, zonedBaseDate);
  if (diffMinutes < 1) {
    return locale === "ko" ? "\uBC29\uAE08 \uC804" : "Just now";
  }
  if (diffHours < 1) {
    return locale === "ko" ? `${diffMinutes}\uBD84 \uC804` : `${diffMinutes}m`;
  }
  if (diffDays < 1) {
    return locale === "ko" ? `${diffHours}\uC2DC\uAC04 \uC804` : `${diffHours}h`;
  }
  if (diffCalDays === 1) {
    return locale === "ko" ? "\uC5B4\uC81C" : "Yesterday";
  }
  if (diffMonths < 1) {
    return locale === "ko" ? `${diffDays}\uC77C \uC804` : `${diffDays} day${diffDays > 1 ? "s" : ""} ago`;
  }
  if (diffYears < 1) {
    return locale === "ko" ? `${diffMonths}\uB2EC \uC804` : `${diffMonths} month${diffMonths > 1 ? "s" : ""} ago`;
  }
  return locale === "ko" ? `${diffYears}\uB144 \uC804` : `${diffYears} year${diffYears > 1 ? "s" : ""} ago`;
};

module.exports = formatRelativeTime;
//# sourceMappingURL=formatRelativeTime.cjs.map
